<template>
  <div class="flex m-8 justify-start flex-wrap">
    <div class="md:max-w-xs w-full mb-4 md:mb-0">
      <p class="pb-2 text-gray-500 font-medium">Información básica personal</p>
      <p class="text-sm text-gray-400 mb-4">
        Llena tus datos básicos, para enviarte la información completa con los
        detalles de tu proyecto.
      </p>
      <div class="w-full">
        <div class="flex">
          <label class="block text-sm font-medium leading-5 text-gray-700"
            >Copiar datos de proyecto</label
          >
        </div>
        <select-buttons
          class="mt-1"
          v-model="copyinfo"
          :options="[
            { key: false, name: 'No copiar' },
            { key: true, name: 'Copiar automáticamente' },
          ]"
        ></select-buttons>
      </div>
    </div>

    <div class="flex-1 md:ml-5">
      <div class="flex w-full flex-wrap">
        <div class="w-full lg:w-1/2 mb-4 lg:px-2">
          <label
            for="person_name"
            class="block text-sm font-medium leading-5 text-gray-700"
            >Nombre</label
          >
          <div class="mt-1 relative rounded-md shadow-sm">
            <input
              id="person_name"
              v-model.trim="$v.personalInfo.name.$model"
              type="text"
              required
              class="form-input block w-full sm:text-sm sm:leading-5"
              :class="{
                'pr-10 border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red':
                  $v.personalInfo.name.$error,
              }"
            />
            <div
              v-if="$v.personalInfo.name.$error"
              class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
            >
              <svg
                class="h-5 w-5 text-red-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="w-full lg:w-1/2 mb-4 lg:px-2">
          <label
            for="person_email"
            class="block text-sm font-medium leading-5 text-gray-700"
            >Correo electrónico</label
          >
          <div class="mt-1 relative rounded-md shadow-sm">
            <input
              id="person_email"
              v-model.trim="$v.personalInfo.email.$model"
              type="email"
              required
              :class="{
                'pr-10 border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red':
                  $v.personalInfo.email.$error,
              }"
              class="form-input block w-full sm:text-sm sm:leading-5"
            />
            <div
              v-if="$v.personalInfo.email.$error"
              class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
            >
              <svg
                class="h-5 w-5 text-red-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="w-full lg:w-1/2 mb-4 lg:px-2">
          <label
            for="person_phone"
            class="block text-sm font-medium leading-5 text-gray-700"
            >Teléfono</label
          >
          <div class="mt-1 relative rounded-md shadow-sm">
            <input
              id="person_phone"
              v-model.trim="$v.personalInfo.phone.$model"
              type="text"
              required
              :class="{
                'pr-10 border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red':
                  $v.personalInfo.phone.$error,
              }"
              class="form-input block w-full sm:text-sm sm:leading-5"
            />
            <div
              v-if="$v.personalInfo.phone.$error"
              class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
            >
              <svg
                class="h-5 w-5 text-red-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="w-full lg:w-1/2 mb-4 lg:px-2">
          <label
            for="person_state"
            class="block text-sm font-medium leading-5 text-gray-700"
            >Estado</label
          >
          <div class="mt-1 relative rounded-md shadow-sm">
            <select
              id="person_state"
              aria-label="Estado"
              v-model.trim="$v.personalInfo.state.$model"
              required
              :class="{
                'pr-10 border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red':
                  $v.personalInfo.state.$error,
              }"
              class="form-select relative block w-full rounded-md bg-transparent focus:z-10 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            >
              <option selected disabled>Selecciona un estado</option>
              <option v-for="state in states" :key="state">{{ state }}</option>
            </select>
            <div
              class="absolute inset-y-0 right-0 pr-8 flex items-center pointer-events-none"
              v-if="$v.personalInfo.state.$error"
            >
              <svg
                class="h-5 w-5 text-red-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="w-full lg:w-1/2 mb-4 lg:px-2">
          <label
            for="person_city"
            class="block text-sm font-medium leading-5 text-gray-700"
            >Ciudad</label
          >
          <div class="mt-1 relative rounded-md shadow-sm">
            <select
              id="person_city"
              aria-label="Ciudad"
              v-model.trim="$v.personalInfo.city.$model"
              required
              :disabled="cityIsDisabled"
              :class="{
                'pr-10 border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red':
                  $v.personalInfo.city.$error,
              }"
              class="form-select relative block w-full rounded-md bg-transparent focus:z-10 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            >
              <option selected disabled>Selecciona una ciudad</option>
              <option
                v-for="city in filteredCities"
                :value="city.id"
                :key="city.id"
                >{{ city.city }}</option
              >
            </select>
            <div
              class="absolute inset-y-0 right-0 pr-8 flex items-center pointer-events-none"
              v-if="$v.personalInfo.city.$error"
            >
              <svg
                class="h-5 w-5 text-red-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="w-full lg:w-1/2 mb-4 lg:px-2">
          <label
            for="person_address"
            class="block text-sm font-medium leading-5 text-gray-700"
            >Calle y número</label
          >
          <div class="mt-1 relative rounded-md shadow-sm">
            <input
              id="person_address"
              v-model.trim="$v.personalInfo.address.$model"
              type="text"
              required
              :class="{
                'pr-10 border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red':
                  $v.personalInfo.address.$error,
              }"
              class="form-input block w-full sm:text-sm sm:leading-5"
            />
            <div
              v-if="$v.personalInfo.address.$error"
              class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
            >
              <svg
                class="h-5 w-5 text-red-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="w-full lg:w-1/2 mb-4 lg:px-2">
          <label
            for="person_town"
            class="block text-sm font-medium leading-5 text-gray-700"
            >Colonia</label
          >
          <div class="mt-1 relative rounded-md shadow-sm">
            <input
              id="person_town"
              v-model.trim="$v.personalInfo.town.$model"
              type="text"
              required
              :class="{
                'pr-10 border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red':
                  $v.personalInfo.town.$error,
              }"
              class="form-input block w-full sm:text-sm sm:leading-5"
            />
            <div
              v-if="$v.personalInfo.town.$error"
              class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
            >
              <svg
                class="h-5 w-5 text-red-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="w-full lg:w-1/2 mb-4 lg:px-2">
          <label
            for="person_postal_code"
            class="block text-sm font-medium leading-5 text-gray-700"
            >Código postal</label
          >
          <div class="mt-1 relative rounded-md shadow-sm">
            <input
              id="person_postal_code"
              v-model.trim="$v.personalInfo.postal_code.$model"
              type="text"
              required
              :class="{
                'pr-10 border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red':
                  $v.personalInfo.postal_code.$error,
              }"
              class="form-input block w-full sm:text-sm sm:leading-5"
            />
            <div
              v-if="$v.personalInfo.postal_code.$error"
              class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
            >
              <svg
                class="h-5 w-5 text-red-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';

function inArray(array) {
  return function(value) {
    return array.includes(value);
  };
}

export default {
  props: {
    cities: { type: Array },
    states: { type: Array },
    personalInfo: {type: Object},
    projectInfo: {type: Object}
  },
  computed: {
    filteredCities() {
      if (this.personalInfo.state) {
        return this.cities.filter((city) => city.state.trim() === this.personalInfo.state.trim());
      }
      return this.cities;
    },
    cityIsDisabled() {
      return this.personalInfo.state ? false : true;
    },
  },
  data() {
    return {
      copyinfo: false,
    };
  },
  validations() {
    return {
      personalInfo: {
        name: {
          required,
        },
        email: {
          required,
          email,
        },
        phone: {
          required,
        },
        state: {
          required,
          inStatesArray: inArray(this.states),
        },
        city: {
          required,
          inCitiesArray: inArray([
            ...new Set(this.filteredCities.map((a) => a.id)),
          ]),
        },
        address: {
          required,
        },
        town: {
          required,
        },
        postal_code: {
          required,
        },
      },
    };
  },
  watch: {
    personalInfo: {
      deep: true,

      handler() {
        this.$emit('personal-info-changed', this.personalInfo);
      },
    },
    projectInfo: {
      deep: true,

      handler() {
        if (this.copyinfo) {
          this.personalInfo.state = this.projectInfo.state;
          this.personalInfo.city = this.projectInfo.city;
          this.personalInfo.address = this.projectInfo.address;
          this.personalInfo.town = this.projectInfo.town;
          this.personalInfo.postal_code = this.projectInfo.postal_code;
        }
      },
    },
    copyinfo: {
      handler() {
        if (this.copyinfo) {
          this.personalInfo.state = this.projectInfo.state;
          this.personalInfo.city = this.projectInfo.city;
          this.personalInfo.address = this.projectInfo.address;
          this.personalInfo.town = this.projectInfo.town;
          this.personalInfo.postal_code = this.projectInfo.postal_code;
        }
      },
    }
  },
};
</script>
